<div class="container-fluid px-4" style="background-color: #ebeff5;">
  <div class="row">
    <div class="col-md-12">
      <div class="row p-4 m-0 border bg-white rounded shadow">
        <div class="col-md-12">
          <div class="row">
            <div class="h5">
              Companies
            </div>
            <dx-data-grid
              id="gridContainer"
              [dataSource]="dataSource"
              rowAlternationEnabled="true"
              [hoverStateEnabled]="true"
              keyExpr="id"
              [selectedRowKeys]="[]"
            >
              <dxo-editing
                mode="cell"
                [refreshMode]="'full'"
                [allowAdding]="false"
                [allowUpdating]="canEdit()"
                [allowDeleting]="canEdit()"
              >
              </dxo-editing>
              <dxo-selection mode="single"></dxo-selection>
              <dxo-export [enabled]="true" [fileName]="getExportFileName()"></dxo-export>

              <dxi-column dataField="id" [visible]="false"></dxi-column>
              <dxi-column dataField="name" caption="Name">
                <dxi-validation-rule type="required"></dxi-validation-rule>
              </dxi-column>
              <dxi-column dataField="address1" caption="Address 1"> </dxi-column>
              <dxi-column dataField="address2" caption="Address 2"> </dxi-column>
              <dxi-column dataField="city" caption="City"></dxi-column>
              <dxi-column dataField="country" caption="Country"></dxi-column>
              <dxi-column dataField="postal_code" caption="Postal code"></dxi-column>
              <dxi-column dataField="region" caption="Region"></dxi-column>
              <dxi-column dataField="created_at" dataType="date" caption="Created At"></dxi-column>
              <dxi-column *ngIf="canEdit()" [width]="'auto'" dataField="login_as" caption="Company Type">
                <dxi-validation-rule type="required"></dxi-validation-rule>
                <dxo-lookup
                  [dataSource]="loginAsData"
                ></dxo-lookup>
              </dxi-column>
              <dxi-column *ngIf="canEdit()" [width]="'auto'" dataField="plan" caption="Plan">
                <dxi-validation-rule type="required"></dxi-validation-rule>
                <dxo-lookup
                  [dataSource]="planData"
                ></dxo-lookup>
              </dxi-column>
            </dx-data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
